/* Uses the facility landing's platform decision, dialog, OAuth and request transport. */
(() => {
    'use strict';
    const escape = value => { const span = document.createElement('span'); span.textContent = value; return span.innerHTML; };
    window.setupProfileLanding = (state, openAuth) => {
        state.root.addEventListener('click', event => {
            const button = event.target.closest('[data-profile-action]');
            if (!button) return;
            event.preventDefault();
            openAuth({ kind: state.root.dataset.profileKind, id: state.root.dataset.profileId, action: button.dataset.profileAction });
        }, { signal: state.events.signal });
    };
    window.resumeProfileLanding = async (state, request) => {
        const root = state.root, kind = root.dataset.profileKind, id = root.dataset.profileId;
        const dialog = root.querySelector('dialog'), title = root.querySelector('[data-profile-resume-title]');
        const content = root.querySelector('[data-profile-resume-content]');
        const consume = () => request(state, '/ProfileLanding/Consume', {}, 'POST');
        try {
            const data = await request(state, '/ProfileLanding/Action', { kind, id });
            if (!root.isConnected) return;
            if (data.action === 'complete') { location.assign(data.redirectUrl); return; }
            if (data.action === 'profile') { await consume(); return; }
            if (data.action === 'chat') {
                const chat = [...document.querySelectorAll('.profile-legacy .messageFriendBtn')].find(x => x.dataset.member === id);
                if (!chat) throw new Error('Bu profil için sohbet şu anda kullanılamıyor.');
                await consume(); chat.click(); return;
            }
            if (data.action === 'follow' || data.action === 'join') {
                const type = data.action === 'join' ? 4 : kind === 'team' ? 3 : 2;
                const html = await request(state, '/_GlobalActionBtnArea', { type, objectId: id }, 'POST', true);
                if (!root.isConnected) return;
                // The existing action UI preserves pending requests and prevents unfollow/cancel on resume.
                const modal = window.createModal({ title: data.action === 'join' ? 'Takıma katıl' : kind === 'team' ? 'Rakip listene ekle' : 'Oyuncuyu takip et' });
                modal.updateContent(html);
                await consume(); return;
            }
            if (data.action === 'invite') {
                const matches = await request(state, '/ProfileLanding/InviteMatches', { kind, id });
                title.textContent = 'Maç ilanını seç.';
                content.innerHTML = '<p>Davet göndermek istediğin maçını seç. Sonraki adımda daveti onaylayacaksın.</p>';
                if (matches.length) {
                    content.insertAdjacentHTML('beforeend', `<div class="pl-profile-invite-list">${matches.map(match => `<button type="button" class="pl-profile-choice" data-profile-match="${Number(match.id)}"><i class="fa-solid fa-futbol" aria-hidden="true"></i><span><strong>${escape(match.label)}</strong><small>Maç #${Number(match.id)}</small></span><i class="fa-solid fa-chevron-right" aria-hidden="true"></i></button>`).join('')}</div>`);
                } else content.insertAdjacentHTML('beforeend', '<p class="pl-profile-empty">Henüz davet gönderebileceğin yaklaşan bir maçın yok. Önce ücretsiz bir maç ilanı oluşturabilirsin.</p>');
                content.insertAdjacentHTML('beforeend', '<button type="button" class="pl-btn pl-btn--lime" data-profile-create-match><i class="fa-solid fa-plus" aria-hidden="true"></i><em>Maç ilanı oluştur</em></button>');
                content.addEventListener('click', event => {
                    const match = event.target.closest('[data-profile-match]');
                    if (match) {
                        const trigger = document.createElement('button');
                        trigger.className = kind === 'team' ? 'sendinOrganizerMatchRequestBtn' : 'inviteMatchPlayerBtn';
                        trigger.dataset.match = match.dataset.profileMatch;
                        trigger.dataset[kind === 'team' ? 'team' : 'member'] = id;
                        trigger.hidden = true; document.body.append(trigger); dialog.close(); trigger.click(); trigger.remove();
                    }
                    if (event.target.closest('[data-profile-create-match]')) { dialog.close(); window.CreateMatchPopUp(0, kind === 'team' ? Number(id) : 0); }
                }, { signal: state.events.signal });
                dialog.showModal(); await consume(); return;
            }
        } catch (error) {
            if (!root.isConnected) return;
            title.textContent = 'Seçimine devam edemedik.';
            content.innerHTML = `<p class="pl-resume-error" role="alert">${escape(error.message)}</p><button type="button" class="pl-btn pl-btn--lime" data-profile-retry><em>Yeniden dene</em></button>`;
            content.querySelector('button').addEventListener('click', () => window.resumeProfileLanding(state, request), { once: true });
            if (!dialog.open) dialog.showModal();
        }
    };
    window.dispatchEvent(new Event('profile-landing:ready'));
})();
